const CLICKSTREAM_DEBUG = import.meta.env.VITE_CLICKSTREAM_DEBUG;
const CLICKSTREAM_TOKEN = import.meta.env.VITE_CLICKSTREAM_TOKEN;
const CLICKSTREAM_URL = import.meta.env.VITE_CLICKSTREAM_URL;

export { CLICKSTREAM_DEBUG, CLICKSTREAM_TOKEN, CLICKSTREAM_URL };
